import React from 'react';
import {
  initializeCollection,
  PagedCollectionProvider,
  usePagedCollectionDispatch,
  usePagedCollectionState,
} from 'Context/PagedCollectionContext';

const StateContext = React.createContext(undefined);
const DispatchContext = React.createContext(undefined);

const ManagedAccountTradeConfirmationDocumentsContextProvider = ({
  tradeConfirmationDocumentsSelfLink,
  ...rest
}) => {
  if (!tradeConfirmationDocumentsSelfLink) {
    const { children } = rest;
    return children;
  }

  return (
    <PagedCollectionProvider
      StateContext={StateContext}
      DispatchContext={DispatchContext}
      initialState={{
        collectionSelfLink: tradeConfirmationDocumentsSelfLink,
      }}
      {...rest}
    />
  );
};

const initializeManagedAccountTradeConfirmationDocumentsCollection = (dispatch, linkUrl) => {
  initializeCollection(dispatch, linkUrl);
};

const useManagedAccountTradeConfirmationDocumentsDispatchContext = () => {
  const context = usePagedCollectionDispatch(DispatchContext);

  if (!context) throw new Error('useManagedAccountTradeConfirmationDocumentsDispatchContext must be called from DispatchContext.Provider');

  return context;
};

const useManagedAccountTradeConfirmationDocumentsStateContext = () => {
  const context = usePagedCollectionState(StateContext);

  if (!context) throw new Error('useManagedAccountTradeConfirmationDocumentsDispatchContext must be called from StateContext.Provider');

  return context;
};

export {
  ManagedAccountTradeConfirmationDocumentsContextProvider,
  useManagedAccountTradeConfirmationDocumentsDispatchContext,
  useManagedAccountTradeConfirmationDocumentsStateContext,
  initializeManagedAccountTradeConfirmationDocumentsCollection,
};
